module.exports = __webpack_public_path__ + "img/safari-help.03f2c539.jpg";